























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { FitmentStatus } from '@shared/helpers/fitment/getFitmentStatus';
import { UCIcon } from '@shared/ui';

import { FITMENT } from '~/constants';

export default defineComponent({
  name: 'ProductCardFitment',
  components: {
    UCIcon,
  },
  props: {
    fitmentStatus: {
      type: String as PropType<FitmentStatus>,
      required: true,
    },
    fittingPositions: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      FITMENT,
    };
  },
});
